import React from 'react';
import { StandardPdfTemplate } from '../../templates/StandardPdfTemplate';
import { ProjectData, ProjectInfoData } from '../../shared/types/PdfCommonTypes';
import { TFunction } from 'i18next';
import { IProjectInfo, IGeogridData } from '../../../../api/IApiResponse';
import { RailwayResultsCore } from './sections/RailwayResultsCore';
import { RailwayGeoGridCore } from './sections/RailwayGeoGridCore';

interface RailwayCombinedResultsPdfDocumentProps {
    projectInfo: IProjectInfo | undefined | null;
    dynamicProject: any;
    output: any;
    geoGridData: IGeogridData | undefined | null;
    tireImageUnreinforced?: string;
    tireImageReinforced?: string;
    geogridImage?: string;
    t: TFunction;
}

const RailwayCombinedResultsPdfDocumentV2: React.FC<RailwayCombinedResultsPdfDocumentProps> = ({
    projectInfo,
    dynamicProject,
    output,
    geoGridData,
    tireImageUnreinforced,
    tireImageReinforced,
    geogridImage,
    t,
}) => {
    const projectData = dynamicProject?.data;
    const projectType = projectData?.type || 'railways';
    const unitSystem = projectData?.unit || 'Metric';

    // Prepare data for StandardPdfTemplate
    const projectDataForTemplate: ProjectData = {
        projectName: projectData?.projectName || 'N/A',
        projectType: projectType,
        unit: unitSystem,
        mapImage: projectData?.mapImage,
    };

    const projectInfoDataForTemplate: ProjectInfoData = {
        data: {
            nrProject: projectInfo?.data?.nrProject || 'N/A',
        },
        projectOwner: projectInfo?.projectOwner || 'N/A',
        designerFirmName: projectInfo?.designerFirmName || 'N/A',
        designerFirmCountry: projectInfo?.designerFirmCountry || 'N/A',
        designerFirmCity: projectInfo?.data?.designerFirmCity || 'N/A',
        coordinates: projectInfo?.coordinates || [null, null],
    };

    // Prepare railway images for RailwayResultsCore
    const railwayImages = {
        tireImageUnreinforced: tireImageUnreinforced || '',
        tireImageReinforced: tireImageReinforced || '',
    };

    return (
        <StandardPdfTemplate
            projectType={projectType}
            projectData={projectDataForTemplate}
            projectInfoData={projectInfoDataForTemplate}
            t={t}
            headerConfig={{
                customTitle: t('pdf_header_technical_report_groundmac') || 'GROUNDMAC - Design Technical Report',
                customProjectType: t('project_type_railway') || 'Railway',
                showGeogridSubtitle: true,
            }}
            footerConfig={{
                customText: t('pdf_footer') || 'MACread eDesign',
                customNotice: t('pdf_footer_notice') || 'Footer notice',
            }}
            showProjectInfo={true}>
            {/* Use the shared core component for Railway Results */}
            <RailwayResultsCore
                railwayImages={railwayImages}
                projectData={projectData}
                output={output}
                t={t}
                showInputData={true}
                showResults={true}
                customTitle="Project Results"
            />

            {/* Use the shared core component for GeoGrid Results */}
            <RailwayGeoGridCore
                geoGridData={geoGridData || undefined}
                geogridImage={geogridImage}
                projectData={projectData}
                t={t}
                showInputData={true}
                showGeoGridImage={true}
                showCourseResults={true}
                customTitle="GeoGrid Reinforcement Analysis"
            />
        </StandardPdfTemplate>
    );
};

export default RailwayCombinedResultsPdfDocumentV2;
